import { Door, MobileOpCode, Visitor } from 'graphql/generated/graphqlTypes';
import { Translation } from 'hooks/useTranslation/useTranslation';
import { AccessFilterAction } from 'v2/utils/accessEvents';
import { FilterEventDetail, FilterEventDetailValue } from './eventFilterTypes';

export interface EventVisitorOption {
  id: string;
  label: string;
  email: Visitor['email'];
}

export interface EventDeviceOption {
  id: string;
  label: string;
}

export interface EventDetailOption {
  key: FilterEventDetailValue;
  label: string;
}

export const getEventVisitorOptions = (visitors: Visitor[]): EventVisitorOption[] =>
  visitors.map((visitor) => ({
    label: visitor.name,
    email: visitor.email,
    id: visitor.id
  }));

export const getEventDeviceOptions = (doors: Door[]): EventDeviceOption[] =>
  doors.map((door) => ({
    label: door.name,
    id: door.id
  }));

export const getEventAccessLabel = (access: AccessFilterAction, translation: Translation): string => {
  switch (access) {
    case MobileOpCode.AccessGranted:
      return translation.granted;
    case MobileOpCode.AccessDenied:
      return translation.denied;
    case MobileOpCode.ResultPending:
      return translation.unverified_event;
    default: {
      const exhaustiveCheck: never = access;
      return exhaustiveCheck;
    }
  }
};

export const getEventDetailLabel = (detail: FilterEventDetailValue, translation: Translation): string => {
  switch (detail) {
    case FilterEventDetail.NoToken:
      return translation.no_token;
    case FilterEventDetail.DomUnknown:
      return translation.unknown;
    default: {
      const exhaustiveCheck: never = detail;
      return exhaustiveCheck;
    }
  }
};

export const getEventDetailOptions = (translation: Translation): EventDetailOption[] =>
  Object.values(FilterEventDetail).map((key) => ({ key, label: getEventDetailLabel(key, translation) }));
